import React, {useEffect} from 'react';
import BaseDialog from '../BaseDialog';
import useApiControl from '../../../common/useApiControl';

const AddFollowDialog = ({isVisible, onClose, dialogDatas, isFollowed, addFollow, removeFollow}) => {
  
  const params = {
    id: dialogDatas?.id,
  };

  const { data: data1, loading: loading1, executeRequest: executeRequest1 } = useApiControl({
      action: '/add_follow',
      params: params,
      method: 'POST',
  });

  const { data: data2, loading: loading2, executeRequest: executeRequest2 }  = useApiControl({
    action: '/remove_follow',
    params: params,
    method: 'POST',
});

  const handleOnClick1 = () => {
    executeRequest1().catch((error) => {
      console.error(error);
    });
    addFollow(dialogDatas.id);
    onClose();
  }

  const handleOnClick2 = () => {
    executeRequest2().catch((error) => {
      console.error(error);
    });
    removeFollow(dialogDatas.id);
    onClose();
  }

  useEffect(() => {
    onClose();
  }, [data1,data2]);

    return (
      <div>
        <BaseDialog
          isVisible={isVisible}
          onClose={() => onClose()}
        >
          {!isFollowed(dialogDatas.id) && (
          <div
           onClick={() => handleOnClick1()}
          >
            このユーザーをフォロー(⋈◍＞◡＜◍)。✧♡
          </div>
          )}
          {isFollowed(dialogDatas.id) && (
            <div
            onClick={() => handleOnClick2()}
          >
            このユーザーのフォローを外す
          </div>
          )}
        </BaseDialog>
      </div>
    );
};

export default AddFollowDialog;